import React from 'react';
import { graphql } from 'gatsby';
import { OmTabsTable } from '@om/component-library-react';
import Table from './Table';



const TabsTable = ({ tabsTable, slot}) => {

    const {
        has_boundary,
        is_extended,
        tab_text_1,
        tab_text_2,
        tab_text_3,
        tab_text_4,
        tab_text_5,
        tab_text_6,
        table_one,
        table_two,
        table_three,
        table_four,
        table_five,
        table_six
    } = tabsTable;

    return (
        <section>
            <OmTabsTable
                slot={slot}
                hasBoundary={has_boundary}
                isExtended={is_extended}
                tabText1={tab_text_1}
                tabText2={tab_text_2}
                tabText3={tab_text_3}
                tabText4={tab_text_4}
                tabText5={tab_text_5}
                tabText6={tab_text_6}
            >
                <Table slot="table-container-one" tableContent={table_one[0]} />
                <Table slot="table-container-two" tableContent={table_two[0]} />
                <Table slot="table-container-three" tableContent={table_three[0]} />
                <Table slot="table-container-four" tableContent={table_four[0]} />
                <Table slot="table-container-five" tableContent={table_five[0]} />
                <Table slot="table-container-six" tableContent={table_six[0]} />
            </OmTabsTable>
        </section>
    )
}

export const pageQuery = graphql`
fragment TabsTable on Contentstack_tabs_table  {
    uid
    has_boundary
    is_extended
    tab_text_1
    tab_text_2
    tab_text_3
    tab_text_4
    tab_text_5
    tab_text_6
    table_one {
        ...Table
    }
    table_two {
        ...Table
    }
    table_three {
        ...Table
    }
    table_four {
        ...Table
    }
    table_five {
        ...Table
    }
    table_six {
        ...Table
    }
  }
`;

export default TabsTable;